let productCardSwiper = null;
let productCardNavigation = null;
const productCardSliderSelector =
  ".product-item .swiper:not(.swiper-initialized)";
let pendingProductCardInit = false;
const initProductCardSliders = (root = document) => {
  if (!productCardSwiper || !productCardNavigation) return;
  const targetRoot = root && root.querySelectorAll ? root : document;
  initSlider(
    productCardSliderSelector,
    productCardSwiper,
    productCardNavigation,
    targetRoot,
  );
};
const scheduleProductCardInit = (root = document) => {
  if (pendingProductCardInit) return;
  pendingProductCardInit = true;
  requestAnimationFrame(() => {
    pendingProductCardInit = false;
    initProductCardSliders(root);
    lipscore.reInitWidgets(true);
  });
};

// Custom events script for re-initializing widgets, sliders, and click events for size guides

(() => {
  let chipsHighlightTimeout = null;

  const focusVariantChips = (trigger) => {
    const chipsWrapper = document.querySelector(".product__color-chips");
    if (!chipsWrapper) return;

    if (chipsHighlightTimeout) {
      clearTimeout(chipsHighlightTimeout);
      chipsHighlightTimeout = null;
    }
    chipsWrapper.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    chipsWrapper.classList.add("inset");
    chipsHighlightTimeout = window.setTimeout(() => {
      chipsWrapper.classList.add("is-highlighted");
      chipsHighlightTimeout = null;
    }, 50);
  };

  import(flu.chunks.swiper).then((_ref) => {
    let { Swiper, Navigation } = _ref;
    productCardSwiper = Swiper;
    productCardNavigation = Navigation;
    initProductCardSliders(document);
  });

  document.addEventListener("collection:updated", () => {
    // console.log("Collection updated event received", productCardSwiper, productCardNavigation);
    scheduleProductCardInit(document);
  });
  document.addEventListener("pageshow", () =>
    scheduleProductCardInit(document),
  );
  document.addEventListener("shopify:section:load", (event) => {
    scheduleProductCardInit(event.target);
  });

  // Event listener for click events on the document
  document.addEventListener("click", function (event) {
    const selectSizeTrigger = event.target.closest(
      ".product-form__select-size, .sticky-atc-bar__meta-change-option-trigger",
    );

    if (selectSizeTrigger) {
      focusVariantChips(selectSizeTrigger);
      return;
    }

    // size guide popup toggle
    if (
      event.target.closest(".custom-collapsable-content-heading") ||
      event.target.classList.contains("custom-collapsable-content-heading")
    ) {
      const content =
        event.target.closest(".custom-collapsable-content-heading") ||
        event.target;
      content.classList.toggle("active");
    }
    if (document.body.classList.contains("template-product")) {
      const clickedLabel = event.target.closest(".marking-label");
      const clickedPopup = event.target.closest(".sustainability-popup");
      const clickedDismiss = event.target.closest(
        ".sustainability-popup__dismiss-icon",
      );

      if (clickedLabel) {
        const popupTarget = clickedLabel.dataset.sustainabilityPopupTarget;
        const popup = document.querySelector(
          '[data-sustainability-popup="' + popupTarget + '"]',
        );
        if (popup) {
          if (popup.parentElement !== document.body) {
            document.body.appendChild(popup);
          }
          popup.classList.add("sustainability-popup-active");
          document.body.classList.add("popup-open");
        }
      }

      if (
        clickedDismiss ||
        (clickedPopup &&
          event.target.classList.contains("sustainability-popup"))
      ) {
        clickedPopup?.classList.remove("sustainability-popup-active");

        if (
          !document.querySelector(
            ".sustainability-popup.sustainability-popup-active",
          )
        ) {
          document.body.classList.remove("popup-open");
        }
      }
    }
    if (
      event.target.closest(".price-icon-wrapper") ||
      event.target.classList.contains("price-icon-wrapper")
    ) {
      const priceWrapper =
        event.target.closest(".price-icon-wrapper") ||
        event.target.classList.contains("price-icon-wrapper");
      if (
        event.target.classList.contains(".price-icon-tooltip") ||
        event.target.closest(".price-icon-tooltip")
      ) {
        if (
          event.target.classList.contains("price-icon-cross") ||
          event.target.closest(".price-icon-cross")
        ) {
          priceWrapper.classList.remove("active");
        }
        return;
      }
      priceWrapper.classList.add("active");
    }
  });

  document.addEventListener("product:variant-change", function (evt) {
    const cartSubmit = document.querySelector(
      ".sticky-atc-bar__button .product-form__cart-submit",
    );
    const selectSize = document.querySelector(
      ".sticky-atc-bar__button .product-form__select-size",
    );
    const changeSize = document.querySelector(
      ".sticky-atc-bar__meta-change-option-trigger",
    );

    if (cartSubmit) {
      cartSubmit.classList.remove("hidden");
    }
    if (changeSize) {
      changeSize.classList.remove("hidden");
    }
    if (selectSize) {
      selectSize.classList.add("hidden");
    }
  });
})();

function updateRelLinks() {
  const nextPageLink = document.querySelector('link[rel="next"]');
  const prevPageLink = document.querySelector('link[rel="prev"]');
  const loadMoreBtnWrapper = document.querySelector(
    ".collection__infinite-trigger",
  );
  const nextPagebtn = loadMoreBtnWrapper.querySelector('a[rel="next"]');
  if (!nextPagebtn && nextPageLink) {
    nextPageLink.remove();
  }
  if (prevPageLink) {
    const prevPageUrlSplit = prevPageLink.href.split("=");
    const prevPageUrl =
      prevPageUrlSplit[0] + "=" + (Number(prevPageUrlSplit[1]) + 1);
    prevPageLink.setAttribute("href", prevPageUrl);
  }
  if (nextPagebtn) {
    const nexPageUrl = nextPagebtn.href;
    const nextPageNumber = Number(nextPagebtn.dataset.pageNumber);
    if (nextPageLink) {
      nextPageLink.setAttribute("href", nexPageUrl);
    }
    if (nextPageNumber > 2 && !prevPageLink) {
      const prevPageUrlSplitArr = nexPageUrl.split("?page=");
      const prevPageUrl = nexPageUrl.split("=")[0];
      const prevPageUrlPageNumber = Number(prevPageUrlSplitArr[1]) - 2;
      const prevPageUrlwithNumber = prevPageUrl + "=" + prevPageUrlPageNumber;
      nextPageLink.insertAdjacentHTML(
        "beforebegin",
        '<link rel="prev" href=' + prevPageUrlwithNumber + ">",
      );
    }
  }
}

function initSlider(selector, Swiper, Navigation, root = document) {
  const elements = Array.from(root.querySelectorAll(selector));
  elements.forEach((element) => {
    if (element.classList.contains("swiper-initialized")) return;
    const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const pointerOptions = isCoarsePointer
      ? {}
      : {
          allowTouchMove: false,
          simulateTouch: false,
          preventClicks: false,
          preventClicksPropagation: false,
          touchStartPreventDefault: false,
          touchStartForcePreventDefault: false,
        };
    const nextEl = element.querySelector(".slider-next");
    const prevEl = element.querySelector(".slider-prev");
    const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;
    new Swiper(element, {
      slidesPerView: "auto",
      loop: true,
      modules: [Navigation],
      ...pointerOptions,
      ...(navigation ? { navigation } : {}),
    });
  });
}
